import React from "react";
import {useMediaQuery} from "@mui/material";

import OutlinedButton from "./../../components/buttons/Outlined";
import ContainedButton from "./../../components/buttons/Contained";

import styles from './PresentSection.module.scss';
import {COLORS, EMOJIS} from "../../../../../config/constants";
import H4 from "../../components/typography/H4";

function PresentSection() {
    const isMobile = useMediaQuery('(max-width: 767px)');

    return (
        <div className={styles.section}>
            <div className={styles.sectionContainer}>
                <div className={styles.sectionTop}>
                    <span className={styles.emoji}>
                        {EMOJIS.GIFT}
                    </span>
                    <div className={styles.title}>
                        <H4 sx={{
                            color: COLORS.WHITE,
                        }}>
                            For new partners: <span className={styles.free}>free</span> onboarding and API setup support
                        </H4>
                    </div>
                </div>
                <div className={styles.buttonsBlock}>
                    <OutlinedButton isBlack icon={isMobile ? null : 'play'} mobileSpacing="tight" fixedMobileHeight subduedMobileBorder>Watch demo</OutlinedButton>
                    <ContainedButton isWhite icon={isMobile ? null : 'handshake'} mobileSpacing="tight" fixedMobileHeight>Become a partner</ContainedButton>
                </div>
            </div>
        </div>
    );
}

export default PresentSection
